




































import { Component, Vue, Prop, Watch } from "vue-property-decorator"
@Component({})
export default class voucherTotal extends Vue {
    @Prop([Number, String])
    loanTotal:any;

    @Prop([Number, String])
    creditTotal:any;

    @Prop({type:Boolean})
    showChineseTotal:any;
    
    @Prop({type:String})
    chineseTotal:any;
    
    jfmoney: any = new Array(11);
    dfmoney:any = new Array(11);
    
    @Watch("loanTotal",{deep: true})
    loanTotalChange(val:any){
        this.fitMoney("jfmoney", "loanTotal")
    }

    @Watch("creditTotal",{deep: true})
    creditTotalChange(val:any){
        this.fitMoney("dfmoney", "creditTotal")
    }

    arrayRemove(arr: any[], v: string) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] === v) {
                arr.splice(i, 1);
                break;
            }
        }
    }
    
    fitMoney(attr:any, atr:any) {
        (<any>this)[attr] = new Array(11);
        // let money  = this.rows[this.rowIndex][attr];
        if ((<any>this)[atr] != 0) {
            let arr = String((<any>this)[atr]).split("").reverse(), j, hasDot = arr.indexOf(".");
            if (arr.indexOf("-") != -1) {
                // arr.remove("-");
                this.arrayRemove(arr, "-");
            }
            if (hasDot == -1) {
                j = 8;
                (<any>this)[attr][9] = "0";
                (<any>this)[attr][10] = "0";
            } else {
                j = 10;
                this.arrayRemove(arr, ".");
            }
            for (var i = 0; i < arr.length; i++) {
                (<any>this)[attr][j] = arr[i];
                j--;
            }
        } else {
            (<any>this)[attr] = new Array(11)
        }
    }
}
